import React from 'react';
import './Blogs.css'
const Blogs = () => {
    return (
        <div className='container row'>
            <h2>FAQ</h2>
            <div className="col-md-6">
                <h4>01. Authorization এবং Authentication এর মধ্যে পার্থক্য</h4>
                <p>Authorization দ্বারা বুঝায় কাউকে অনুমোদন প্রদান করা । একটি ওয়েব সাইট বিভিন্ন ব্যবহারকারী হতে পারে কিন্তু সবার কাজ সমান নয়। কেউ হয়তো সাধারণ ব্যবহারকারী এবং কেউ হইতো এটার মালিক। যিনি মালিক তিনি ওয়েবসাইটটির বিভিন্ন কন্টেন্ট পরিবর্তন করতে পারেন এবং সাধারণ ব্যবহার কারীরা কেবল সেটা দেখতে পারেন, এই ব্যাপারটিই মূলত Authorization. Authorization এর দ্বারা ঠিক করা হয় কোন User কোন সুবিধা উপভোগ করতে পারবে এবং পারবে না।
                </p>
                <p>
                Authentication তথা প্রমাণীত করা। এর দ্বারা কোন ওয়েব সাইটের Login / Sign in করা কে বুঝায়। ওয়েব সাইটে কিছু কিছু অংশ সকল ব্যবহার কারীদের থেকে লুকিয়ে শুধুমাত্র যারা রেজিস্ট্রেশন আছে তাদের কে নিদিষ্ট কোন পেইজের অনুমোদন দেওয়া হয় এবং এ ক্ষেত্রে ব্যবহার করা হয় Authentication. কেননা, এর মাধ্যমে নির্ধারণ করা হয় যে, User যে protected পেইজের অ্যাক্সেস করতে চাচ্ছে তার জন্য সে যোগ্য কি না, যদি তিনি রেজিস্ট্রেশন করে থাকেন তবে তিনি এটা পাবেন অর্থাৎ উক্ত পেইজে প্রবেশ করতে পারবেন অন্যথায় পারবেন না।
                </p>
            </div>
            <div className="col-md-6">
                <h4>02. Firebase Authentication ছাড়া অন্য কি কি সেবা প্রদান করে?</h4>
                <p>নিন্মে কয়েকটি পয়েন্ট দিয়ে Firebase এর Authentication ছাড়া অনন্যা সার্ভিস গুলো উল্লেখ করা হলঃ
                (1) Email and password, Google, Facebook, এবং Github এর মাধ্যমে authentication করা যায়।
                (02) ডাটাবেস রিয়েল টাইম ডাটাবেস এর মাধ্যমে Ready-made api এর সুবিধা পাওয়া যায়।
                (3) Data node level এ সিকিউরিটি প্রদান করে।
                (4) ফাইল স্টোরেজ করা যায়।
                (5) ক্লাউড স্টোরেজ করা যায়।
                (6) স্ট্যাটিক ফাইল হোস্টিং করা যায়।
                </p>
            </div>
        </div>
    );
};

export default Blogs;